import {
    LOCALES_SET_LANGUAGE,
    SEARCH_OPEN,
    // NEWSLETTER_POPUP,
    MENU_OPEN
} from '../constants'
import locale from '../../config/locale'

const initialState = {
    locale: localStorage.getItem(locale.name),
    searchOpen: false,
    // newsletterOpen: false,
    menuOpen: false
}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case LOCALES_SET_LANGUAGE:
            return {
                ...state,
                locale: action.locale
            }
        case SEARCH_OPEN:
            return {
                ...state,
                searchOpen: action.open
            }
        // case NEWSLETTER_POPUP:
        //     return {
        //         ...state,
        //         newsletterOpen: action.store
        //     }
        case MENU_OPEN:
            return {
                ...state,
                menuOpen: action.open
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/globalReducer.js